import {
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import apiClient from '../client';
import {
  MeetingTypeView,
  ApiError,
  ApiPlatformCollectionResponse,
  extractCollectionItems,
} from '../types';

export const meetingTypeKeys = {
  all: ['meetingTypes'] as const,
  lists: () => [...meetingTypeKeys.all, 'list'] as const,
  list: (locale?: string) => [...meetingTypeKeys.lists(), { locale }] as const,
  details: () => [...meetingTypeKeys.all, 'detail'] as const,
  detail: (id: number, locale?: string) =>
    [...meetingTypeKeys.details(), id, { locale }] as const,
};

export const useMeetingTypes = (
  locale?: string,
  options?: Omit<UseQueryOptions<MeetingTypeView[], ApiError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<MeetingTypeView[], ApiError>({
    queryKey: meetingTypeKeys.list(locale),
    queryFn: async () => {
      const params = locale ? { locale } : undefined;
      const response = await apiClient.get<ApiPlatformCollectionResponse<MeetingTypeView>>('/meeting_types', params);
      return extractCollectionItems(response.data);
    },
    ...options,
  });
};

export const useMeetingType = (
  id: number,
  locale?: string,
  options?: Omit<UseQueryOptions<MeetingTypeView, ApiError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<MeetingTypeView, ApiError>({
    queryKey: meetingTypeKeys.detail(id, locale),
    queryFn: async () => {
      const params = locale ? { locale } : undefined;
      const response = await apiClient.get<MeetingTypeView>(
        `/meeting_types/${id}`,
        params
      );
      return response.data;
    },
    enabled: !!id,
    ...options,
  });
};



